import {CurrentRightsService, GroupRights, groupRights, IGroupRights} from "@services/current-rights.service";
import {inject} from "@angular/core";
import {CanActivateFn, RedirectCommand, Router} from "@angular/router";
import {CurrentService} from "@/app/api/current.service";
import {filter, map} from "rxjs";
import {Current} from "@models/sportexam";

export const guard = (role: groupRights) => (group: keyof IGroupRights): CanActivateFn => () => {
    const router = inject(Router);
    const rights = inject(CurrentRightsService);
    const current = inject(CurrentService);

    return current.current
        .pipe(
            filter(Boolean),
            map((user: Current) => {
                    const res = new GroupRights(role, user.data.rights.none)[group];
                    if (!res) {
                        const loginPath = router.parseUrl("/access-denied");
                        return new RedirectCommand(loginPath, {
                            skipLocationChange: true,
                        });
                    }

                    return true;
                }
            )
        )
}

